<div style="position: relative;">
  <div class="stakeDiv">
    <h3>stake</h3>
    <dl class="setting-block stake-setting" id="">
      <dd *ngFor="let arr of stArr;let i=index;">
        <input name="stackVal{{i}}" [(ngModel)]="stacks['stake_amount_'+ (i+1)]" type="number" (change)="stacks['stake_name_'+ (i+1)] = stacks['stake_amount_'+ (i+1)]+'';" />
      </dd>
      <dd class="col-stake_edit"><a class="btn-send ui-link" href="javascript:;" id="save" (click)="setBtnVal()">Save</a>
      </dd>
    </dl>
  </div>
  <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>
</div>
